export default "__VITE_ASSET__BckJHR8h__"